<script>
    import {VuetablePaginationMixin} from './../vuetable-2'
    import {nextTick} from "vue";
    export default {
        mixins: [VuetablePaginationMixin],
        data() {
            return {
                inputPage: 0,
            }
        },
        computed: {
            currentPage(){
                return this.tablePagination === null
                    ? 0
                    : this.tablePagination.current_page
            },
            nextPageInterval(){
                if(this.currentPage + this.windowSize - 1 >= this.totalPage){
                    return this.totalPage
                }
                return this.currentPage + this.windowSize - 1;
            },
            prevPageInterval(){
                if(this.currentPage - this.windowSize + 1 <= 0){
                    return 1;
                }
                return this.currentPage - this.windowSize + 1;
            }
        },
        methods: {
            doLoadPage(){
                if(this.currentPage === this.inputPage){
                    return false;
                }

                this.loadPage(this.inputPage);
            },
            onFocus() {
                let self = this;
                nextTick(() => {
                    self.$refs["inputPage"].select();
                });
            }
        },
        watch: {
            currentPage() {
                this.inputPage = this.currentPage;
            }
        },
    }
</script>
<template>
    <ul class="pagination">
        <li :class="{'disabled': isOnFirstPage}">
            <a href="" @click.prevent="loadPage('prev')">
                <span>&laquo;</span>
            </a>
        </li>

        <li v-if="currentPage >= (windowSize - windowStart) && !simplePagination">
            <a @click.prevent="loadPage(1)" v-html="1"></a>
        </li>

        <li v-if="currentPage >= (windowSize - windowStart) && !simplePagination">
            <a @click.prevent="loadPage(prevPageInterval)">...</a>
        </li>

        <template v-if="notEnoughPages">
            <li v-for="n in totalPage" :class="{'active': isCurrentPage(n)}" v-if="!simplePagination">
                <a @click.prevent="loadPage(n)" v-html="n.formatMoney(0, ' ', ' ')"></a>
            </li>
        </template>
        <template v-else>
            <li v-for="n in windowSize" :class="{'active': isCurrentPage(windowStart + n - 1)}" v-if="!simplePagination">
                <a @click.prevent="loadPage(windowStart + n - 1)" v-html="(windowStart + n - 1).formatMoney(0, ' ', ' ')"></a>
            </li>
        </template>

        <li v-if="(windowStart + windowSize) < totalPage && !simplePagination">
            <a @click.prevent="loadPage(nextPageInterval)">...</a>
        </li>

        <li v-if="(windowStart - 1 + windowSize) < totalPage && !simplePagination">
            <a @click.prevent="loadPage(totalPage)" v-html="totalPage.formatMoney(0, ' ', ' ')"></a>
        </li>

        <li :class="{'disabled': isOnLastPage}">
            <a href="" @click.prevent="loadPage('next')">
                <span>&raquo;</span>
            </a>
        </li>
        <li>
            <input type="number"
                   v-if="!simplePagination"
                   ref="inputPage"
                   v-model="inputPage"
                   @keyup.enter="doLoadPage"
                   @focus="onFocus"
                   min="1"
                   :max="totalPage"
                   :title="$t('lang.main.table.placeholder_input_page')"/>
        </li>
    </ul>
</template>
